import { Column } from "components/common/Layout/Column";
import { Row } from "components/common/Layout/Row";
import { useEffect, useState } from "react";
import TransportDriverService from "services/TransportDriverService";
import useSelectedSector from "hooks/useSelectedSector";
import { Checkbox, Typography, Box, Paper } from "@mui/material";
import LoadingBox from "components/common/LoadingBox/LoadingBox";
import TransportDriversList from "./TransportDriversList";
import { TransportDriver } from "types/TransportDriver";

type Props = {
  onDriversFetched: (drivers: TransportDriver[]) => void;
};

export default function ActiveTransportDrivers({ onDriversFetched }: Props) {
  const { selectedSectorId } = useSelectedSector();
  const [showAll, setShowAll] = useState(false);

  const { data: activeTransportDrivers } = TransportDriverService.useGetTransportDriversQuery(
    {
      sectorId: showAll ? undefined : selectedSectorId,
      isActive: true,
    },
    { refetchOnMountOrArgChange: true },
  );

  useEffect(() => {
    if (activeTransportDrivers) onDriversFetched(activeTransportDrivers);
  }, [activeTransportDrivers]);

  return (
    <Box sx={{ p: 2 }}>
      <Paper elevation={0} sx={{ p: 2, mb: 2, bgcolor: "background.default" }}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: "primary.main" }}>
          Conductores de Transporte
        </Typography>

        <Row alignItems="center" sx={{ mb: 2 }}>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            Incluir de todos los sectores
          </Typography>
          <Checkbox checked={showAll} onChange={() => setShowAll((prev) => !prev)} sx={{ ml: 1 }} />
        </Row>

        {activeTransportDrivers && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {activeTransportDrivers.length} conductor{activeTransportDrivers.length !== 1 ? "es" : ""}
            {showAll ? " en total" : " en este sector"}
          </Typography>
        )}
      </Paper>

      {activeTransportDrivers ? <TransportDriversList drivers={activeTransportDrivers} /> : <LoadingBox />}
    </Box>
  );
}
